import { useContext } from "react";
import { ApplicationContext } from "../context/ApplicationContext";

const useAuthUser = () => useContext(ApplicationContext);
export default useAuthUser;
